import { DataLoadURL } from '@workflow/ecp-shared/model/dataload-url';

// TODO: do we need all these /mortgage/ consts?
export const Loan_api = {
  GetPaymentConfig: {
    hostName: 'consumerPortalApi',
    method: 'GET',
    url: 'consumer/mortgage/payment/PaymentConfig'
  } as DataLoadURL,
  ProcessCreditCardTransaction: {
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'consumer/mortgage/payment/ProcessCreditCardTransaction'
  } as DataLoadURL,
  GetACHTransaction: {
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'consumer/mortgage/payment/GetACHTransaction'
  } as DataLoadURL,
  GetCreditCardTransaction: {
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'consumer/mortgage/payment/GetCreditCardTransaction'
  } as DataLoadURL,
  SavePaymentDetails: {
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'consumer/mortgage/payment/{{loanNumber}}/savepaymentdetails'
  } as DataLoadURL,
  UpdateTransactionResult: {
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'consumer/mortgage/payment/{{loanNumber}}/UpdatePaymentResponse'
  } as DataLoadURL,
  LegalDocument: {
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'document/legalDocument'
  } as DataLoadURL
};
